import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { apiPath, RoutePath } from "../../utility/Constant";

const TeamCreate = () => {
  const { teamListApi } = apiPath;
  const { teamList } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "file",
      label: "Member Photo",
      type: "file",
      name: "image",
      required: false,
    },
    {
      elementType: "input",
      label: "Member Name",
      type: "Text",
      name: "name",
      required: true,
    },
    {
      elementType: "input",
      label: "Member Designation",
      type: "Text",
      name: "designation",
      required: true,
    },
    {
      elementType: "textField",
      label: "Member Description",
      type: "Text",
      name: "description",
      required: false,
    },
  ];
  const multiDimensionalData = [
    {
      elementType: "nested",
      label: "Social Links",
      name: "social",
      multiple: true,
      required: false,
    },
  ];

  const useData = data.concat(multiDimensionalData);

  const update = (data) => {
    updateData(teamListApi, data, null, null, null, true);
    navigate("/" + teamList);
  };

  return (
    <div>
      <GlobalForm
        data={useData}
        multiDimensionalData={multiDimensionalData}
        update={update}
      />
    </div>
  );
};

export default TeamCreate;
